import React from 'react';

import './css/Page.css'

import { Footer } from './Footer';

import { TraceBackground } from './TraceBackground';
import { fadeEngine } from './Fade';

interface PageProps {
	title: string
	className: string
	children: React.ReactNode
}

// Shell of every page but the home page: a band of reverse-time traces under
// the menu, the page's own sections, then the footer. Sets the document title
// while mounted and starts the fade engine, which scans the DOM for its
// data-attributes and so must run once the content is in place.
export function Page( { title, className, children }: PageProps ): React.JSX.Element {

	React.useEffect( (): ( () => void ) => {
		const previousTitle: string = document.title
		document.title = title

		fadeEngine.useEffect()

		return (): void => {
			document.title = previousTitle
		}
	}, [ title ] );

	return (
		<div className={ `Page ${ className }` } >
			<TraceBackground />

			{ children }

			<Footer />
		</div>
	)
}
